import { gql } from '@apollo/client';
import { MediaQueries } from '@minecraft.shared-queries';

export const QUERY_SUBMISSION_DETAILS = gql`
  query publicProfile($guid: String!, $roleId: Float!) {
    publicProfile(guid: $guid) {
      id
      stageName
      defaultSubmissionNote
      submission(roleId: $roleId) {
        id
        note
        requestedMedia {
          ...SubmissionMedia
        }
      }
    }
  }
  ${MediaQueries.submissionMediaFragment}
`;
